import { z } from 'zod/v4'

export const paginationLinksSchema = z.object({
    first: z.string().nullable(),
    last: z.string().nullable(),
    next: z.string().nullable(),
    prev: z.string().nullable(),
})

export const paginationMetaSchema = z.object({
    current_page: z.number(),
    from: z.number().nullable(),
    last_page: z.number(),
    path: z.string(),
    per_page: z.number(),
    to: z.number().nullable(),
    total: z.number(),
})
